<style>
.my-red-button {
  background-color: #e53935 !important; /* red */
  color: white !important;
  border: none;
  box-shadow: none;
}

.my-red-button:hover {
  background-color: #c62828 !important;
}

</style>

<template>
  <div>
    <div>
      
      <!-- Booking Entries -->
      <div  v-if=" currentView === 'mainDetailsViewMore'">
        <!-- <div v-else> -->
        <div v-if="bookings && bookings.length > 0">
          <div
            v-for="(booking, index) in bookings"
            :key="booking.id"
            class="content-box p-5 mt-3 mb-3"
            :id="`booking-block-${index + 1}`"
          >
            <!-- SUMMARY VIEW -->
            <div :id="`summary-view-${index + 1}`" style="position: relative;" >
              <h5>Booking Details in {{ booking.slot?.entity || 'N/A' }}</h5>
              <div class="row my-4">
                <div class="col-md-4">
                  <p class="mb-2">Name : {{ booking.name || 'N/A' }}</p>
                  <p class="mb-2">Phone Number : {{ booking.phone || 'N/A' }}</p>
                  <p class="mb-2">No of Applicants : {{ booking.totalapplicants }}</p>
                  
                  <p class="mb-2" :title="booking.email">Email Address : 
                    <span style="word-break: break-all;">{{ booking.email || 'N/A' }}</span>
                  </p>
                  
                  <!-- <p class="mb-2">Country : {{ booking.slot?.entity || 'N/A' }}</p> -->

                </div>
                <div class="col-md-4">
                  <p class="mb-2">Booking No : {{ booking.booking_no }}</p>
                  <p class="mb-2">Slot Date : {{ formatDate(booking.slot?.start_time) }}</p>
                  <p class="mb-2">
                    Slot Time :
                    {{ formatTimeRange(booking.slot?.start_time, booking.slot?.end_time) }}
                  </p>
                  
                  <p class="mb-2">Booked On : {{ formatDate(booking.created_at) || 'N/A' }}</p>
                </div>
                <div class="col-md-4">
                  <button class="btn w-100 mb-2 cancel-btn py-3 px-4" 
                    v-if="!isApplicationsEmpty(booking) && booking.slot?.booking_closed === false &&
                    booking.is_cancelled === false && !allApplicantsCancelled(booking)"
                    @click="confirmEntireCancel(booking.id, booking.booking_no, booking.phone, booking.name, booking.email)">
                    Cancel Appointment
                  </button>
                  <button
                    class="btn w-100 view-btn py-3 px-4"
                    @click="toggleDetails(index)"
                  >
                    View More Details
                  </button>
                </div>
              </div>
              
            </div>
          

            <ViewDetailsMore  v-if=" currentView === 'mainDetailsViewMore' && showDetailIndex === index" :booking="booking" :formProgress="applicantFormProgress"  @close="showDetailIndex = null"  @change-view="currentView = $event"/>
            
            

          </div>
        </div>
        <div v-else class="card text-center p-5 mt-4 shadow-sm">
          <h5 class="mb-2">No Records Found</h5>
          <p class="text-muted mb-0">There are no bookings available.</p>
        </div>
      </div>


      <div v-else-if="currentView === 'detailsReschedule'">
        <ResheduleEntireDetails  :booking="bookings[showDetailIndex]"  @back="currentView = 'mainDetailsViewMore'"/>
      </div>

      <div v-else-if="currentView === 'detailsSingleReschedule'">
        <SingleDetailsReshedule  :booking="bookings[showDetailIndex]" @back="currentView = 'mainDetailsViewMore'"/>
      </div>
      
      <div v-else-if="currentView === 'detailsSingleEdit'">
        <DetailsEditForm  :booking="bookings[showDetailIndex]" @back="currentView = 'mainDetailsViewMore'"/>
      </div>

      <div v-else-if="currentView === 'detailsEntirePageEdit'">
        <EditEntireDetailsForm  :booking="bookings[showDetailIndex]" @back="currentView = 'mainDetailsViewMore'"/>
      </div>

      <div v-else-if="currentView === 'detailsEditNewMember'">
        <EditNewMember  :booking="bookings[showDetailIndex]" @back="currentView = 'mainDetailsViewMore'"/>
      </div>

      


      <div class="modal fade" id="otpApplicationHistoryModal" tabindex="-1" aria-labelledby="otpModalLabel" aria-hidden="true">
          <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content p-4 rounded-4">
              <div class="modal-body">
                <img src="@/assets/Images/Logo/kims-logo.png" alt="KIMSHEALTH" class="mb-3" style="max-width:260px;">
                <p class="otp_text mb-4">Please Enter the OTP received on your registered mobile number</p>
                <div class="d-flex justify-content-center mb-3 gap-1 otp-input-group flex-wrap justify-content-between">
                  <input
                      v-for="(digit, index) in otp"
                      :key="index"
                      type="text"
                      class="form-control otp-box text-center"
                      maxlength="1"
                      v-model="otp[index]"
                      @input="focusNext(index, $event)"
                      @keydown.backspace="focusPrev(index, $event)"
                      ref="otpInputs"
                  />
                  
                </div>  
                <small v-if="errors.otpError" class="text-danger">{{ errors.otpError }}</small>            
                <a  @click="validationEntireCancelMain()" :disabled="loading" class="btn confirm-btn w-100 mb-3">
                  <span v-if="!loading">Confirm</span>
                  <span v-else>
                      <i class="fa fa-spinner fa-spin"></i> Processing...
                  </span>
                </a>
                <div class="d-flex justify-content-between">
                  <span class="resend">Resend OTP in <span class="timer">{{ formattedTime }}</span></span>
                  <a href="#" class="resend_btn text-decoration-none" @click="handleResend()" :disabled="resendloading">
                    <span v-if="!resendloading">Resend</span>
                    <span v-else>
                      <i class="fa fa-spinner fa-spin"></i> Resending...
                    </span>
                  </a>
                </div>
              </div>
            </div>
          </div>
      </div>


    </div>


    <div id="preloader" v-if="entirePageLoading" style="position: fixed; top:0; left:0; width:100%; height:100%; background: rgba(255,255,255,0.8); z-index: 9999; display:flex; flex-direction:column; justify-content:center; align-items:center;">
      <img src="@/assets/Images/Logo/preloader.png" alt="Loading Image" style="width:100px;">
      <p>Loading...</p>
    </div>

  </div>
  
</template>

<script>
import ViewDetailsMore from '@/components/Appointment/Sections/Details/More/ViewDetailsMore.vue';
import { useUserStore } from '@/store/user';
import Swal from 'sweetalert2';
import { GetCompletedBYBookings,PurposeSendOtp, PurposeVerifyOtp, PurposeCancelAllBookings } from '@/api/Post/track.js';
import { RescheduleEntireBooking, LogoutPage } from '@/api/Post/action.js';
import ResheduleEntireDetails from '@/components/Appointment/Sections/Details/ResheduleEntireDetails.vue';
import SingleDetailsReshedule from '@/components/Appointment/Sections/Details/SingleDetailsReshedule.vue';
import DetailsEditForm from '@/components/Appointment/Sections/Details/DetailsEditForm.vue';
import EditEntireDetailsForm from '@/components/Appointment/Sections/Details/More/EditEntireDetailsForm.vue';
import EditNewMember from '@/components/Appointment/Sections/Details/More/EditNewMember.vue';
export default {
  name: 'AppointmentDetails',
  components: {
    ViewDetailsMore,
    ResheduleEntireDetails,
    SingleDetailsReshedule,
    DetailsEditForm,
    EditEntireDetailsForm,
    EditNewMember
  },
  data() {
    const otpData = {
      expire_in: 3
    };
    let expireInMinutes = parseInt(otpData.expire_in); 
    let expireInSeconds = expireInMinutes * 60;

    if (isNaN(expireInSeconds)) {
        //console.error("Invalid expire_in value:", otpData.expire_in);
        expireInSeconds = 180; 
    }
    return {
      loading: true,
      bookings: [],
      applicantFormProgress: [],
      showDetailIndex: null,
      entirePageLoading: false,
      otp: ['', '', '', '', ''],
      errors: {},
      timer: expireInSeconds, 
      otpData: otpData,
      timerActive: true,
      resendloading: false,
      resendCount: 0,
      resendDisabled: false,
      phoneNumber: '',
      name: '',
      email: '',
      participant: '',
      bookingId: null,
      showNextComponent: false,
      currentView: 'mainDetailsViewMore',
      booking_no: null,
    };
  },
  watch: {
    $route(to, from) {
      this.loadBookingHistory();
    }
  },
  computed: {
      formattedTime() {
        const minutes = Math.floor(this.timer / 60);
        const seconds = this.timer % 60;
        return `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
      },
  },
  mounted() {
    this.loadBookingHistory();
      // if (this.timer > 0) {
      //     this.startTimer();
      // } 
      // else {
      //   console.error("Invalid expire_in value:", this.timer);  
      // }
  },
  methods: {
    async loadBookingHistory() {
      this.entirePageLoading = true;
      try {
        const userStore = useUserStore();
        //const phone = userStore.phone;
        //const token = userStore.authToken;
        const phone = localStorage.getItem('phoneSession');
        const response = await GetCompletedBYBookings(phone);
        //await new Promise(resolve => setTimeout(resolve, 100));
        if (response?.data?.success) {
          ///console.log("Booking details 23 : ", JSON.stringify(response.data.applicant_form_progress, null, 2));
          this.applicantFormProgress = response.data.applicant_form_progress;
          this.bookings = response.data.data;
          this.bookingId = this.bookings[0].id;
          this.booking_no = this.bookings[0].booking_no;
          ///console.log('this.bookings.booking_no in load booking history : ', this.bookings[0].booking_no);
          //console.log("booking now?", JSON.stringify(this.bookings, null, 2));
        }
      } catch (error) {
        //console.error("Booking fetch error", error);
      } finally {
        this.entirePageLoading = false;
        this.loading = false;
      }
    },
    

    allApplicantsCancelled(booking) {
      if (!booking.applications || !Array.isArray(booking.applications)) return false;

      let totalApplicants = 0;
      let cancelledApplicants = 0;

      for (const application of booking.applications) {
        if (!Array.isArray(application.applicants)) continue;

        for (const applicant of application.applicants) {
          totalApplicants++;
          if (applicant.cancel_status === true) {
            cancelledApplicants++;
          }
        }
      }

      ///console.log(`Booking #${booking.booking_no} — Total Applicants: ${totalApplicants}, Cancelled: ${cancelledApplicants}`);

      return totalApplicants > 0 && totalApplicants === cancelledApplicants;
    },

    isApplicationsEmpty(booking) {
      //console.log('hai bab:');
      //console.log('this.booking.applications.length : ', booking.applications.length);
      return !booking?.applications || booking.applications.length === 0;
    },


    formatDate(date) {
      if (!date) return 'N/A';
      return new Date(date).toLocaleDateString(undefined, {
        year: 'numeric',
        month: 'short',
        day: 'numeric'
      });
    },
    formatTimeRange(start, end) {
      if (!start || !end) return 'N/A';
      const s = new Date(start).toLocaleTimeString([], {
        hour: '2-digit',
        minute: '2-digit',
        hour12: true
      });
      const e = new Date(end).toLocaleTimeString([], {
        hour: '2-digit',
        minute: '2-digit',
        hour12: true
      });
      return `${s} - ${e}`;
    },
    toggleDetails(index) {
      this.showDetailIndex = this.showDetailIndex === index ? null : index;
    },
    changeView(view) {
      ////console.log('view::', view);
      this.currentView = view
    },

    async validationEntireCancelMain() {
        
        const enteredOtp = this.otp.join('');
        this.errors.otpError = '';
        if (enteredOtp.length !== 5 || this.otp.some(digit => digit === '')) {
          this.errors.otpError = "Please enter a valid 5-digit OTP.";
          return;
        }

        this.loading = true;

        const userStore = useUserStore();
        const loggedUser = userStore.user;
        let participant = loggedUser?.user_id;

        if (!participant) {
          const localUser = JSON.parse(localStorage.getItem('userId'));
          participant = localUser?.user_id || null;
        }

        if (!participant) {
          //console.error("No user_id found in store or localStorage.");
          this.errors.otpError = "Session expired. Please log in again.";
          return;
        }

        const purpose = 'Cancel';
        ///console.log('purpose ----------------------------------: ', purpose);
        ///console.log('this.bookingId ----------------------------------: ', this.bookingId);
        ///console.log('this.enteredOtp -------------------------------------: ', enteredOtp);
        
        PurposeVerifyOtp(participant, purpose, enteredOtp)
          .then((response) => {
            const res = response.data;

            if (!res.success || !res.verified) {
              this.errors.otpError = 'OTP is Invalid or Expired.';
              return;
            }
            //console.log('this.bookingId ----------------------------------: ', this.bookingId);
            //console.log('this.enteredOtp -------------------------------------: ', enteredOtp);
            // OTP verified, proceed to cancel bookings
            return PurposeCancelAllBookings(enteredOtp, this.bookingId)
              .then((cancelResponse) => {
                const cancelRes = cancelResponse.data;
                //console.log("Cancel Response:", cancelRes);
                if (cancelRes.success === true || cancelRes.success === 'true') {
                  Swal.fire({
                    title: `Booking #${this.booking_no}`,
                    text: cancelRes.message || 'Bookings cancelled successfully.',
                    confirmButtonText: 'OK',
                    allowOutsideClick: false,
                    showClass: {
                      popup: 'animate__animated animate__fadeInDown',
                    },
                    hideClass: {
                      popup: 'animate__animated animate__fadeOutUp',
                    },
                    customClass: {
                      confirmButton: 'my-red-button',
                    },
                  }).then(() => {
                    LogoutPage()
                      .then(() => {
                        localStorage.removeItem('authToken');
                        this.$router.push({ name: 'trackAppointment' });
                      })
                      .catch((error) => {
                        //console.error("Logout Error:", error);
                        this.$swal.fire({
                          icon: 'error',
                          title: 'Logout Failed',
                          text: 'Please try again.',
                        });
                      });
                  });
                } else {
                  this.$swal.fire({
                    icon: 'error',
                    title: 'Error',
                    text: cancelRes.message || 'Failed to cancel bookings.',
                  });
                }
                // if (cancelRes.success) {
                //   this.$toast.success(cancelRes.message || 'Bookings cancelled successfully.', {
                //     position: 'top-right',
                //     duration: 2000,
                //   });
                //   setTimeout(() => {
                //     LogoutPage()
                //       .then(() => {
                //         localStorage.removeItem('authToken');
                //         this.$router.push({ name: 'trackAppointment' });
                //       })
                //       .catch((error) => {
                //         console.error("Logout Error:", error);
                //         this.$toast.error('Logout failed. Please try again.', {
                //           position: 'top-right',
                //           duration: 3000,
                //         });
                //       });
                //   }, 2000);
                  
                // } else {
                //   this.$toast.error(cancelRes.message || 'Failed to cancel bookings.', {
                //     position: 'top-right',
                //     duration: 3000,
                //   });
                // }
              })
              .catch((error) => {
                //console.error("CancelAllBookings Error:", error.response?.data || error);
                this.$toast.error('Failed to cancel bookings. Please try again.', {
                  position: 'top-right',
                  duration: 3000,
                });
              })
              .finally(() => {
                const modalEl = document.getElementById('otpApplicationHistoryModal');
                if (modalEl) {
                  const otpModal = bootstrap.Modal.getInstance(modalEl);
                  if (otpModal) otpModal.hide();
                }
                ///console.log("OTP verified and modal closed.");
              });
          })
          .catch((error) => {
            if (error.response && error.response.data) {
              const serverMessage = error.response.data.message;
              //console.error("Backend Error:", serverMessage);
              this.errors.otpError = serverMessage || "Something went wrong. Please try again.";
            } else if (error.request) {
              //console.error("No response received:", error.request);
              this.errors.otpError = "No response from server. Please check your internet or try again.";
            } else {
              //console.error("Request setup error:", error.message);
              this.errors.otpError = error.message || "Something went wrong.";
            }
          })
          .finally(() => {
            this.loading = false;
          });



        
    },

    async confirmEntireCancel(bookingId, booking_no, phoneNumber, name, email) {
        const result = await Swal.fire({
          title: 'Are you sure?',
          html: `This action will cancel the appointment with booking number <span style="color: black; font-weight: bold;">${booking_no}</span>.`,
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Yes, cancel it!',
          cancelButtonText: "Don't, Cancel",
          showClass: {
            popup: `animate__animated animate__fadeInUp animate__faster`,
          },
          hideClass: {
            popup: `animate__animated animate__fadeOutDown animate__faster`,
          }
        });

        if (!result.isConfirmed) return;

        const userStore = useUserStore();
        const loggedUser = userStore.user;
        let participant = loggedUser?.user_id;

        if (!participant) {
          const localUser = JSON.parse(localStorage.getItem('userId'));
          participant = localUser?.user_id || null;
        }

        if (!participant) {
          //console.error("No user_id found in store or localStorage.");
          this.errors.otpError = "Session expired. Please log in again.";
          return;
        }

        const purpose = 'Cancel';
        this.bookingId = bookingId;

        Swal.fire({
          title: 'Sending OTP...',
          text: 'Please wait while we send an OTP to your registered mobile number.',
          allowOutsideClick: false,
          allowEscapeKey: false,
          didOpen: () => {
            Swal.showLoading();
          }
        });

        this.phoneNumber = phoneNumber;
        this.name = name;
        this.email = email;
        this.participant = participant;

        try {
          const response = await PurposeSendOtp(participant, phoneNumber, purpose, name, email);
          Swal.close();

          if (response.data.success === false) {
            this.errors.otpError = response.data.message || 'Something went wrong.';
            return;
          }

          this.resendCount++;
          this.timer = 180; 
          this.timerActive = true;
          //this.formattedTime = this.formatTime(this.timer);
          this.startTimer();

          if (this.resendCount >= 1) {
            this.resendDisabled = true;
            setTimeout(() => {
              this.resendCount = 0;
              this.resendDisabled = false;
            }, 5 * 60 * 1000);
            
          }

          ///console.log("OTP sent successfully.");
        } catch (error) {
          //console.error("Axios Error:", error);
          Swal.close();
          this.errors.otpError = "Failed to send OTP. Please try again.";
          return;
        }

        this.$nextTick(() => {
          const modalEl = document.getElementById('otpApplicationHistoryModal');
          if (modalEl) {
            const otpModal = new bootstrap.Modal(modalEl);
            otpModal.show();
          }
        });
    },


    focusNext(index, event) {
        if (event.target.value && index < 4) {
          this.$refs.otpInputs[index + 1].focus();
        }
    },
    focusPrev(index, event) {
        if (!this.otp[index] && index > 0) {
          this.$refs.otpInputs[index - 1].focus();
        }
    },


    // startTimer() {
    //     this.stopTimer();

    //     this.countdownInterval = setInterval(() => {
    //       if (this.timer > 0) {
    //         this.timer--;
    //         //this.formattedTime = this.formatTime(this.timer);
    //       } else {
    //         this.stopTimer();
    //       }
    //     }, 1000);
    // },
    startTimer() {
        this.stopTimer();

        this.countdownInterval = setInterval(() => {
            if (this.timer > 0) {
                this.timer--;
            } else {
                this.stopTimer();
            }
        }, 1000);
    },
    stopTimer() {
        clearInterval(this.countdownInterval);
        this.countdownInterval = null;
        this.timerActive = false;
    },
    // formatTime(seconds) {
    //     const m = Math.floor(seconds / 60).toString().padStart(2, '0');
    //     const s = (seconds % 60).toString().padStart(2, '0');
    //     return `${m}:${s}`;
    // },


    async handleResend() {
        //console.log('this.timerL:', this.timer);
        // if (this.resendDisabled || this.resendCount >= 1) {
        //   this.errors.otpError = 'You’ve exceeded the OTP resend limit.';
        //   return;
        // }
        if (this.timer > 0) {
          this.errors.otpError = 'Please wait before resending the OTP.';
          return;
        }

        this.resendloading = true;
        this.errors.otpError = '';
        const purpose = 'Cancel';

        try {
          const sendOTP = await PurposeSendOtp(this.participant, this.phoneNumber, purpose, this.name, this.email);

          if (sendOTP.data.success === true) {
            this.resendCount++;
            this.timer = 180; 
            this.timerActive = true;
            //this.formattedTime = this.formatTime(this.timer);
            this.startTimer();

            if (this.resendCount >= 1) {
              this.resendDisabled = true;
              setTimeout(() => {
                this.resendCount = 0;
                this.resendDisabled = false;
              }, 5 * 60 * 1000);
              
            }

            this.errors.otpError = '';
          } else {
            this.errors.otpError = sendOTP.data.message || 'Error sending OTP.';
          }
        } catch (error) {
          this.errors.otpError = error?.message || 'Something went wrong.';
        } finally {
          this.resendloading = false;
        }
    },


  }
};
</script>
